var meteorologicalStationsManager = require('@managers/meteorologicalStationsManager');
var { error_message } = require('@managers/helpers');

// Middleware
export var load_meteorological_stations = (force = false) => {
  return (dispatch, getState) => {
    var state = getState();
    // Load only once
    if (!state.meteorological_stations_data.stations || force) {
      dispatch(get_meteorological_stations_init());

      meteorologicalStationsManager.getMeteorologicalStations().then(
        function (result) {
          dispatch(get_meteorological_stations_success(result));
        },
        function (err) {
          console.log(err);
          dispatch(get_meteorological_stations_fail(err));
        }
      );
    }
  };
};

export var get_meteorological_stations_init = () => {
  return {
    type: 'GET_METEOROLOGICAL_STATIONS_INIT',
  };
};

export var get_meteorological_stations_success = stations => {
  return {
    type: 'GET_METEOROLOGICAL_STATIONS_SUCCESS',
    stations: stations,
  };
};

export var get_meteorological_stations_fail = err => {
  return {
    type: 'GET_METEOROLOGICAL_STATIONS_FAIL',
    error_message: error_message(err),
  };
};
